/** @jsxImportSource @emotion/react */
import React from 'react'
import { CardApplyForm, CardApplyPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/CardApplyContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, cardApplyManagement } = breadcrumbItems

const CardApplyCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <CardApplyForm />
        </div>
        <div css={styles.right}>
          <CardApplyPreview />
        </div>
      </div>
    </Provider>
  )
}

export default CardApplyCreate;
